import ReactRouterPrompt from "react-router-prompt"
import { useNavigate } from "react-router-dom"
import { useDispatch } from 'react-redux'
import Modal from "@mui/material/Modal"
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import useContentful from "../contexts/useContentful"
import { resetState as qualtricsReset } from '../redux/slices/qualtricsSurveySlice'
import { resetState as globalReset } from '../redux/slices/globalSlice'

const Prompt = ({
  isDirty,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {
    exitPromptTitle,
    exitPromptSubtitle,
    exitPromptCancel,
    exitPromptConfirm,
  } = useContentful()

  const handleConfirm = () => {
    dispatch(qualtricsReset())
    dispatch(globalReset())
    navigate('/')
    // onConfirm()
  }

  return (
    <ReactRouterPrompt 
      when={data => isDirty || data?.historyAction === 'POP'}
    >
      {({ isActive, onConfirm, onCancel }) => (
        <Modal 
          sx={{
            display: 'grid',
            placeItems: 'center',
            placeContent: 'center',
          }}
          open={isActive}
        >
          <Paper
            className="drawn"
            sx={{
              width: '100%',
              justifySelf: 'center',
              maxWidth: 500,
              outline: 'none',
              justifySelf: 'center',
            }}
          >
            <Stack
              p={{
                xs: 2,
                sm: 4,
              }}
            >
              <Typography
                variant="h3"
                textAlign="center"
                mb={1.5}
              >
                {exitPromptTitle}
              </Typography>
              <Typography
                variant="body1"
                textAlign="center"
                mb={4}
              >
                {exitPromptSubtitle}
              </Typography>
              <Stack
                display="grid"
                gridAutoFlow="column"
                gap={3}
                justifyContent="space-between"
                justifyItems="space-between"
                alignItems="center"
              >
                <Button
                  onClick={onCancel}
                >
                  {exitPromptCancel}
                </Button>
                <Link
                  color="text.primary"
                  sx={{
                    cursor: 'pointer',
                  }}
                  onClick={handleConfirm}
                >
                  {exitPromptConfirm}
                </Link>
              </Stack>
            </Stack>
          </Paper>
        </Modal>
      )}
    </ReactRouterPrompt>
  )
}

export default Prompt